var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLandoltC(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "&ns_svg;",
    xmlnsXlink: "&ns_xlink;",
    viewBox: "0 0 127 127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4472c4",
    d: "M99.4,73.5H126c-4.9,30.2-31,53.2-62.6,53.2C28.4,126.8,0,98.4,0,63.4S28.4,0,63.4,0C95,0,121.1,23.1,126,53.3H99.4V73.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "white",
    cx: 63,
    cy: 63.4,
    r: 37.8
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandoltC);
export default __webpack_public_path__ + "static/media/landolt-c.11d877f8e40ae0eff8863edbc7753b2e.svg";
export { ForwardRef as ReactComponent };